module.exports = __webpack_public_path__ + "static/media/promo-code-1.d5123afc.svg";